
import Vue from "vue";
import Component from "vue-class-component";
import XEUtils from "xe-utils";
import NavBread from "../component/NavBread.vue";
import FormInfo from "./FormInfo.vue";

import {
  productBasicInfoLabel,
  productBasicInfoLabelForJY,
  projectBasicInfoLabel,
  productProcessLabel,
  projectProcessLabel,
} from "./conf";
import { Getter, Action } from "vuex-class";
import { Watch } from "vue-property-decorator";
import * as util from "../conf";
import { Message, MessageBox } from "element-ui";
import rely from "@/nmb/oauth2/oauth2rely";

@Component({
  components: {
    NavBread,
    FormInfo,
  },
})
export default class Detail extends Vue {
  $refs: {
    [key: string]: any;
    validate: HTMLFormElement;
  };

  @Getter feedbackDetailV2: any;
  @Getter revokeFeedback: any;
  @Getter feedbackResult: any;
  @Getter savefeedbacktransferResult: any;
  @Getter transferResult: any;
  @Getter exsitFeedbacktransfer: any;
  @Action getFeedbackDetailByIdV2: Function;
  @Action RevokeFeedback: Function;
  @Action updateFeedback: Function;
  @Action transferFeedback: Function;
  @Action updateFeedbackIsFirst: Function;
  @Action("exsitTransfer") exsitTransfer: Function;
  @Action("saveFeedbackTransfer") saveFeedbackTransfer: Function;
  navData: any = [
    { name: "反馈中心", to: { path: "/feedback" } },
    { name: "反馈详情" },
  ];

  centerDialogVisible: boolean = false;

  showFeedbackInfo: boolean = false; // 是否展开详情

  TypeEnum: number = 0; // 反馈类型(1:产品咨询;2:产品建议;3:产品BUG)
  basicInfoLabel: any = JSON.parse(productBasicInfoLabel); // 基本信息的表单lebel
  basicInfoCanEdit: boolean = false;
  basicInfoCanTrans: boolean = false;
  processLabel: any = productProcessLabel; // 进展信息的表单lebel
  detailInfo: any = {};
  detailList: any = [];
  formInfo: any = {}; // 当前显示的产品进展
  btnType: number = 0; // 项目进展和产品进展状态同时为已关闭时才显示重新激活，同时为未关闭时才显示撤销, 1: 撤销，3:重新激活

  tabProcess: string = "产品进展0"; // 进展tab标签
  waitUpdate: boolean = false;
  isTransfer: boolean = true; //  转单显示规则 1、已完成不显示 2、规划中不显示
  transfer: boolean = false; //  转单显示规则 2、如果是经办人，显示     3、  detailInfo.CanTransfer 后台设置了转单权限
  isSatisfy: boolean = true;
  isExistSatisfy: boolean = true;
  subdisabled: boolean = false;
  user: any;
  created() {
    this.TypeEnum = Number(this.$route.query.TypeEnum);
    this.getFeedbackDetailByIdV2({
      FeedbackGUID: this.$route.query.FeedbackGUID,
    });
    this.user = JSON.parse(localStorage.logonUser);
  }

  refresh(val: any) {
    this.subdisabled = val;
  }

  back(){
    this.$router.replace({path: "/feedback?activeIndex=" + this.$route.query.activeIndex});
  }

  mounted() {
    this.basicInfoLabel =
      this.tabProcess.indexOf("产品进展") > -1
        ? JSON.parse(productBasicInfoLabel)
        : JSON.parse(projectBasicInfoLabel);
    this.processLabel =
      this.tabProcess.indexOf("产品进展") > -1
        ? productProcessLabel
        : projectProcessLabel;
    if (this.TypeEnum === 2) {
      this.basicInfoLabel = JSON.parse(productBasicInfoLabelForJY);
    }
  }

  @Watch("feedbackResult.loading")
  watchFeedbackResult(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {
      if (this.feedbackResult.success) {
        this.waitUpdate = true;
        if (!this.transferResult.loading) {
          setTimeout(() => {
            // location.reload();
            this.$router.go(0);
          }, 500);
        }
      }
    }
  }

  /* 协调转单后刷新页面 */
  @Watch("savefeedbacktransferResult.loading")
  watchSavefeedbacktransferResult(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {
      if (this.savefeedbacktransferResult.success) {
        this.basicInfoCanTrans = false;
        if (!this.savefeedbacktransferResult.loading) {
          setTimeout(() => {
            // location.reload();
            this.$router.push({
              path: "/feedback",
              query: { activeIndex: "4" },
            });
          }, 500);
        }
      }
    }
  }

  @Watch("feedbackDetailV2.loading")
  watchFeedbackDetail(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {
      const jiraDetails = this.feedbackDetailV2.data.JiraDetails || [];
      const pdDetails = this.feedbackDetailV2.data.PdDetails || [];
      this.detailList = [jiraDetails, pdDetails];
      if (jiraDetails.length > 0) {
        this.tabProcess = "产品进展" + (jiraDetails.length - 1);
        this.formInfo = jiraDetails[jiraDetails.length - 1];
      } else if (pdDetails.length > 0) {
        this.tabProcess = "项目进展" + (pdDetails.length - 1);
        this.formInfo = pdDetails[pdDetails.length - 1];
      }

      const user = rely.getLogonUser();
      this.detailInfo = this.feedbackDetailV2.data || {};

      // 可编辑条件 创建人 = 提交人 && 只有产品进展 && jira状态不为已关闭 3 不为已兑现5
      this.basicInfoCanEdit =
        this.detailInfo.CreatedGUID === user.UserGUID &&
        !!this.formInfo.JIRAGUID &&
        this.formInfo.SourceEnum === 1 &&
        this.formInfo.StatusEnum !== 3 &&
        this.formInfo.StatusEnum !== 5;
      this.processLabel =
        this.tabProcess.indexOf("产品进展") > -1
          ? productProcessLabel
          : projectProcessLabel;
      if (this.formInfo.SourceEnum === 2) {
        this.basicInfoLabel = JSON.parse(projectBasicInfoLabel);
      }

      // 关闭的单子、是本人 、不是撤单操作 并且不是转单 显示评价按钮
      this.isSatisfy =
        this.formInfo.StatusEnum == 3 &&
        this.detailInfo.CreatedUserCode === user.UserCode &&
        (this.formInfo.RevokeDateTime === null? true: false)
        && this.formInfo.IsTransfer!=true;
      this.isExistSatisfy = this.formInfo.IsSatisy;
      // this.btnType = this.formInfo.StatusEnum;
      this.setBtnType();
      // 是否具有转单权限，配置了转单权限 or 登录人=反馈单经办人
      if (jiraDetails[jiraDetails.length - 1]) {
        this.transfer =
          jiraDetails[jiraDetails.length - 1].OperateUserCode ===
          this.user.UserCode;
      } else if (pdDetails[pdDetails - 1]) {
        this.transfer =
          pdDetails[pdDetails.length - 1].OperateUserCode ===
          this.user.UserCode;
      }
      // 状态是已完成 或规划中 不允许转单
      this.isTransfer =
        this.formInfo.StatusEnum != 3 && this.formInfo.StatusEnum != 4;

      // 重新激活的详情
      if (
        this.formInfo &&
        this.formInfo.OriginalFeedbackGUID === null &&
        this.formInfo.OriginalAnalysis !== null &&
        this.formInfo.OriginalAnalysis !== ""
      ) {
        this.basicInfoLabel.splice(4, 0, [
          { key: "OriginalAnalysis", label: "原反馈分析", wrap: true },
        ]);
      }
      // 首次进入提示,已关闭，详情不存在评价,当前用户是登记人,并且不是撤单操作
      if (
        this.feedbackDetailV2.data.IsFirst == false &&
        this.formInfo.StatusEnum == 3 &&
        this.formInfo.IsSatisfy == false &&
        this.detailInfo.CreatedUserCode === user.UserCode &&
        this.formInfo.RevokeDateTime === null &&
        this.formInfo.IsTransfer!=true
      ) {
        MessageBox.confirm(
          "您的当前反馈单已关闭，我们需要您的评价，是否前往！",
          "提示",
          {
            confirmButtonText: "前往",
            cancelButtonText: "再想想",
            center: true,
          }
        ).then(() => {
          this.satis(this.feedbackDetailV2.data, "add");
        });

        // 更新IsFirst
        this.updateFeedbackIsFirst({
          FeedbackGUID: this.feedbackDetailV2.data.FeedbackGUID,
        });
      }
      // 判断是否存在转单信息
      this.exsitTransfer({
        feedbackDetailGUID: this.formInfo.FeedbackDetailsGUID,
      });
    }
  }
  // 判断按钮状态，项目进展和产品进展状态同时为已关闭时才显示重新激活，同时为未关闭时才显示撤销, 1: 撤销，3:重新激活
  setBtnType() {
    const jiraDetails = this.feedbackDetailV2.data.JiraDetails || [];
    const pdDetails = this.feedbackDetailV2.data.PdDetails || [];
    const details = [...jiraDetails, ...pdDetails];
    let jh = false;
    let cx = false;

    // 最后一个是关闭的 jh=true 否则 jh=false
    details.forEach((item: any) => {
      jh = item.StatusEnum === 3;
    });
    // 如果
    if (jiraDetails.length > 0 && pdDetails.length > 0) {
      cx =
        jiraDetails[jiraDetails.length - 1].StatusEnum ===
          pdDetails[pdDetails.length - 1].StatusEnum &&
        jiraDetails[jiraDetails.length - 1].StatusEnum === 1;
    } else {
      cx =
        (jiraDetails.length &&
          jiraDetails[jiraDetails.length - 1].StatusEnum === 1) ||
        (pdDetails.length && pdDetails[pdDetails.length - 1].StatusEnum === 1);
    }

    if (jh) {
      this.btnType = 3;
    } else if (cx) {
      this.btnType = 1;
    } else {
      this.btnType = 0;
    }
  }

  @Watch("revokeFeedback.loading")
  watchRevokeFeedback(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {
      if (this.revokeFeedback.success) {
        setTimeout(() => {
          this.$router.go(0);
        }, 500);
      }
    }
  }

  // 重新激活
  handleReactivation() {
    const user = JSON.parse(localStorage.logonUser);
    if (this.detailInfo.CreatedUserCode !== user.UserCode) {
      Message.warning("只有登记人才能重新激活反馈信息！");
    } else if (
      this.detailInfo.OriginalFeedbackGUID &&
      this.detailInfo.OriginalFeedbackGUID !== ""
    ) {
      Message.warning("该反馈已重新激活或转单生成新的反馈，无法再次激活！");
    } else {
      const routedata = this.$router.resolve({
        path: `/feedback/entrance/${this.getTypeEnumUri()}`,
        query: { FeedbackGUID: this.$route.query.FeedbackGUID },
      });
      window.open(routedata.href, "_blank");
    }
  }

  // 转单按钮
  handleTransfer() {
    // 判断是否存在转单信息,如果存在转单信息 直接跳转单到转单详情
    if (this.exsitFeedbacktransfer.exsit) {
      Message.warning({
        message: "当前单据已经转过单，请前往转单列表查看",
        showClose: true,
      });
      return;
    }
    const user = rely.getLogonUser();
    // 可编辑条件 创建人 = 提交人 && 只有产品进展 && jira状态不为已关闭 3
    const curEdit =
      this.detailInfo.CreatedGUID === user.UserGUID &&
      !!this.formInfo.JIRAGUID &&
      this.formInfo.SourceEnum === 1 &&
      this.formInfo.StatusEnum !== 3 &&
      this.formInfo.StatusEnum !== 5;

    // 点击转单 子系统可修改，描述、附件不可修改
    // 点击取消转单 子系统可修改，描述、附件不可修改
    if (curEdit) {
      this.basicInfoCanEdit = this.basicInfoCanTrans;
    }
    this.basicInfoCanTrans = !this.basicInfoCanTrans;

    this.showFeedbackInfo = true;
  }

  // 撤销
  handleRevoke() {
    const data = this.feedbackDetailV2.data || {};
    if (data.length > 1) {
      Message.warning("该反馈信息已被提交到JIRA中，不允许撤销！");
    } else {
      const user = JSON.parse(localStorage.logonUser);
      if (this.detailInfo.CreatedUserCode === user.UserCode) {
        this.RevokeFeedback({ FeedbackGUID: this.$route.query.FeedbackGUID });
      } else {
        Message.warning("只有登记人才能撤销反馈信息！");
      }
    }
  }

  getTypeEnumUri() {
    switch (this.TypeEnum) {
      case 1:
        return "consultation";
      case 2:
        return "proposal";
      case 3:
        return "defect";
      default:
        return "";
    }
  }

  /**
   * 切换进展
   */
  changeProcess(tab: string, data: string) {    
    this.tabProcess = tab;
    this.processLabel =
      this.tabProcess.indexOf("产品进展") > -1
        ? productProcessLabel
        : projectProcessLabel;
    this.formInfo = data;
      this.isSatisfy =
        this.formInfo.StatusEnum == 3 &&
        (this.formInfo.RevokeDateTime === null? true: false)
        && this.formInfo.IsTransfer!=true;
    this.isExistSatisfy = this.formInfo.IsSatisy;
          // 状态是已完成 或规划中 不允许转单
      this.isTransfer =
        this.formInfo.StatusEnum != 3 && this.formInfo.StatusEnum != 4;

    // 判断是否存在转单信息
    this.exsitTransfer({
      feedbackDetailGUID: this.formInfo.FeedbackDetailsGUID,
    });
  }

  // 登记人修改 描述 与 更新附件时 保存
  handleSave() {
    const data = this.feedbackDetailV2.data || {};
    const params = this.$refs.baseInfoForm.submmitForm();
    const jiraDetails = data.JiraDetails || [];
    const fileUpload = !!data.FileUpload ? JSON.parse(data.FileUpload) : [];
    const newFileUpload = !!params.FileUpload
      ? JSON.parse(params.FileUpload)
      : [];
    const delFileUpload = !!params.deleteFileUpload
      ? JSON.parse(params.deleteFileUpload)
      : [];

    // 获取新增 删除的附件
    const FileUpload = fileUpload.concat(newFileUpload);
    const new_arr = FileUpload.filter(
      (x: any) => !delFileUpload.some((item: any) => x.uid === item.uid)
    );
    this.updateFeedback({
      FeedbackGUID: data.FeedbackGUID,
      TypeEnum: data.TypeEnum,
      JIRAGUID: jiraDetails[jiraDetails.length - 1].JIRAGUID || "",
      FeedbackDescribe: params.FeedbackDescribe,
      NewFileUpload: JSON.stringify(newFileUpload),
      FileUpload: JSON.stringify(new_arr),
      DeleteFileUpload: JSON.stringify(delFileUpload),
    });
  }
  // 转单确认
  handleTransferSave() {
    const data = this.feedbackDetailV2.data || {};
    // 判断是否存在转单信息,如果存在转单信息 直接跳转单到转单详情
    if (this.exsitFeedbacktransfer.exsit) {
      Message.warning({
        message: "当前单据已经转过单，请前往转单列表查看",
        showClose: true,
      });
    } else {
      this.centerDialogVisible = true;
    }
  }
  validatehandleTransferSubmit(params:any){    
    if (!params.SubSystemGUID && XEUtils.isEmpty(params.SubSystemGUID)) {
      Message.error({message:"子系统不能为空",showClose:true});
      return false;
    }

    if (!params.ModuleGUID && XEUtils.isEmpty(params.ModuleGUID)) {
      Message.error({message:"模块不能为空",showClose:true});
      return false;
    }

    // 除产品建议外，其他类型校验产品版本是否必填 
    if ( this.TypeEnum!=2&&!params.EditionGUID && XEUtils.isEmpty(params.EditionGUID)) {
      Message.error({message:"产品版本不能为空",showClose:true});
      return false;
    }
  }
  // 转单提交
  handleTransferSubmit() {
    const data = this.feedbackDetailV2.data || {};
    const params = this.$refs.baseInfoForm.submitTransform();  
    // 保存前校验
    if(this.validatehandleTransferSubmit(params)==false){
      return;
    }
    // 保存转单信息
    this.saveFeedbackTransfer({
      FeedbackGUID: data.FeedbackGUID,
      BeforeFeedbackDetailsGUID: this.formInfo.FeedbackDetailsGUID,
      AfterFeedbackDetailsGUID: null,
      Theme: data.FeedbackTheme,
      TransferDate: new Date(),
      BeforeSystemCode: data.SubSystemGUID,
      BeforeModuleCode: data.ModuleGUID,
      BeforeProductCode: data.EditionGUID,
      SystemCode: params.SubSystemGUID,
      ModuleCode: params.ModuleGUID,
      ProductCode: params.EditionGUID,
      OperateBy: this.formInfo.OperateUserCode, //转单前经办人
      OperateName: this.formInfo.OperateName, //转单前经办人
      HandlerBy: this.formInfo.HandleUserCode, //转单前处理人
      HandlerName: this.formInfo.HandleName, //转单前处理人

      TransferBy: this.user.UserCode, // 转单人 （当前登陆人）
      TransferName: this.user.UserName,
      ReceiveBy: params.assignee.name, // 接收人（转单后默认经办人）
      ReceiveName: params.assignee.displayname,      
      ReceiveDate: null,
      RejectionReason: "",
      StatusEnum: 1,
      Status: "待转单",
      TypeEnum:this.feedbackDetailV2.data.TypeEnum,
      //...params,
    });
  }
  // 跳转满意度评价
  satis(val: any, view: string) {
    this.$router.push({
      path: "/feedback/satisfaction",
      query: {
        FeedbackGUID: val.FeedbackGUID,
        FeedbackDetailGUID: this.formInfo.FeedbackDetailsGUID,
        TypeEnum: val.TypeEnum,
        FromType: "Detail",
        view: view,
      },
    });
  }
}
